import logo from 'prignano-theme/components/Logo/logo-white.svg';

export default function LogoFooter() {
  return (
    <figure className="footer-logo">
      <img
        src={logo}
        alt="Comune di Prignano sulla Secchia"
        width="82"
        height="82"
        loading="lazy"
        decoding="async"
      />
    </figure>
  );
}
